export default __webpack_public_path__ + "cd6b0314737fa94a81e42689517fd7fb.png";